import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Roles } from './constants/roles';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './layouts/AppLayout';
import LoadingSkeleton from './components/shared/LoadingSkeleton';
import LoginPage from './pages/auth/LoginPage';

const DashboardPage = lazy(() => import('./pages/dashboard/DashboardPage'));
const PricingRulesPage = lazy(() => import('./pages/pricing/PricingRulesPage'));

const App = () => (
  <BrowserRouter>
    <Suspense fallback={<LoadingSkeleton />}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/app"
          element={
            <ProtectedRoute allowedRoles={[Roles.Admin, Roles.User]}>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="pricing-rules" element={<PricingRulesPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default App;
